<div class="mb-5 w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Manage Account Section
    </p>
    <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
      Company Pages
    </h2>
  </div>
</div>

<app-index-company></app-index-company>

<ng-template #loading>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
    <div class="flex flex-col items-center gap-4 rounded-2xl border border-gray-300 bg-white px-8 py-6">
      <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700"></div>
      <p class="text-sm font-medium text-gray-500">
        Loading pages...
      </p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="hasLoaded == true; else loading">
  <main class="px-4 sm:px-5">
    <!-- NAVIGATION -->
    <section class="mb-5">
      <app-index-nav-grid></app-index-nav-grid>
    </section>

    <!-- TOOLBAR -->
    <section class="mb-5 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-center">
      <div class="lg:col-span-6">
        <button
          class="primary-btn h-[50px]"
          (click)="showPlatformModal = true"
        >
          Add New Page
        </button>
      </div>

      <div class="lg:col-span-6">
        <div class="flex justify-end">
          <div class="flex h-[50px] w-full max-w-[260px] items-center rounded-xl border border-gray-300 bg-white px-3">
            <!-- SEARCH ICON -->
            <mat-icon class="flex-shrink-0 text-gray-400">search</mat-icon>

            <!-- INPUT -->
            <input
              #searchInput
              type="text"
              placeholder="Search..."
              (keyup.enter)="onSearchSubmit(searchInput.value)"
              (input)="searchValue = searchInput.value"
              [(ngModel)]="searchValue"
              class="min-w-0 flex-1 bg-transparent px-2 text-sm text-gray-700 outline-none placeholder:text-gray-400"
            />

            <!-- CLEAR BUTTON -->
            <button
              type="button"
              (click)="clearSearch(); searchInput.value=''; searchValue=''"
              [class.opacity-0]="!searchValue"
              [class.pointer-events-none]="!searchValue"
              class="flex h-9 w-9 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg text-gray-500 transition hover:bg-gray-100 hover:text-gray-800"
            >
              <mat-icon class="text-lg">close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- TOP CONTROLS -->
    <section class="mb-4 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-center">
      <div class="hidden lg:col-span-6 lg:block"></div>

      <div class="lg:col-span-6">
        <div class="flex justify-end">
          <div class="w-fit overflow-hidden rounded-2xl border border-gray-300 bg-white">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageSizeOptions]="[pageSize]"
              showFirstLastButtons
              (page)="onPageChange($event)"
              class="!w-auto [&_.mat-mdc-paginator-container]:!min-h-[44px] [&_.mat-mdc-paginator-container]:!px-2 [&_.mat-mdc-paginator-page-size]:!mr-2 [&_.mat-mdc-paginator-range-label]:!mx-2"
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </section>

    <!-- PAGES TABLE -->
    <section class="grid grid-cols-1 gap-4">
      <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
        <div class="w-full overflow-x-auto">
          <mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="onSortChange($event)"
            class="!inline-table !w-full min-w-[1100px] table-fixed table-alternate text-sm"
          >
            <!-- ID COLUMN -->
            <ng-container matColumnDef="id">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[100px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                ID
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[100px] whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800"
              >
                #{{ element.ID || '' }}
              </td>
            </ng-container>

            <!-- THUMBNAIL COLUMN -->
            <ng-container matColumnDef="thumbnail">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="w-[120px] whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Thumbnail
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[120px] px-5 py-5"
              >
                <div class="justify-center">
                  <div>
                    <img
                      [src]="element.thumbnail_file_path || 'https://via.placeholder.com/48'"
                      [alt]="element.title || 'Thumbnail'"
                      class="h-full w-full object-cover"
                      (error)="element.thumbnail_file_path = 'https://via.placeholder.com/48'"
                    />
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- URL COLUMN -->
            <ng-container matColumnDef="url">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                URL
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="px-5 py-5"
              >
                <div class="max-w-[260px] overflow-hidden">
                  <a
                    [href]="element.siteUrl || '#'"
                    target="_blank"
                    class="inline-flex max-w-full items-center gap-2 text-sm font-medium text-gray-800 transition hover:text-blue-600 hover:underline"
                  >
                    <mat-icon class="!text-[18px]">open_in_new</mat-icon>
                    <span class="truncate">
                      {{ element.domain || '---' }}
                    </span>
                  </a>
                </div>
              </td>
            </ng-container>

            <!-- CMS COLUMN -->
            <ng-container matColumnDef="cms">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[170px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                CMS
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[170px] px-5 py-5"
              >
                <div class="max-w-[140px] overflow-hidden">
                  <p class="truncate text-sm font-medium text-gray-700">
                    {{ element.cmsType || '---' | titlecase }}
                  </p>
                </div>
              </td>
            </ng-container>

            <!-- STATUS COLUMN -->
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[150px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Status
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[150px] whitespace-nowrap px-5 py-5"
              >
                <span
                  class="inline-flex w-[100px] items-center justify-center rounded-full px-3 py-2 text-xs font-semibold"
                  [ngClass]="{
                    'bg-green-100 text-green-800': element.is_active === 1 || element.is_active === 1,
                    'bg-gray-100 text-gray-800': element.is_active === 0 || element.is_active === 0,
                    'bg-gray-200 text-gray-800': !element.is_active
                  }"
                >
                  {{
                    element.is_active === 1
                      ? 'Active'
                      : element.is_active === 0
                        ? 'Inactive'
                        : element.is_active || '---'
                  }}
                </span>
              </td>
            </ng-container>

            <!-- CREATED AT COLUMN -->
            <ng-container matColumnDef="created_at">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[190px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Created At
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[190px] whitespace-nowrap px-5 py-5 text-sm text-gray-700"
              >
                {{ (element.created_at | date:'dd/MM/yyyy HH:mm') || '' }}
              </td>
            </ng-container>

            <!-- TOTAL POSTS COLUMN -->
            <ng-container matColumnDef="total_published_posts">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[160px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Total Posts
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[160px] whitespace-nowrap px-5 py-5 text-sm font-semibold text-gray-900"
              >
                {{ (element.total_published_posts) || '0' | number:'1.0-0':'el-GR' }}
              </td>
            </ng-container>

            <!-- ACTIONS COLUMN -->
            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="w-[160px] whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Actions
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="w-[160px] whitespace-nowrap px-5 py-5"
              >
                <div class="flex w-full items-center justify-center gap-1">
                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                    (click)="editPage(element)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-red-600"
                    (click)="deletePage(element)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- TABLE HEADER -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="border-b border-gray-300 bg-gray-50"
            >
            </tr>

            <!-- TABLE ROWS -->
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
            >
            </tr>
          </mat-table>
        </div>
      </div>

      <!-- NO DATA MESSAGE -->
      <div
        *ngIf="dataSource.data.length === 0"
        class="col-span-1 rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-medium text-red-600"
      >
        No Pages found.
      </div>

      <!-- BOTTOM PAGINATOR -->
      <div class="col-span-1 flex justify-end">
        <div class="w-fit overflow-hidden rounded-2xl border border-gray-300 bg-white">
          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageSizeOptions]="[pageSize]"
            showFirstLastButtons
            (page)="onPageChange($event)"
            class="!w-auto [&_.mat-mdc-paginator-container]:!min-h-[44px] [&_.mat-mdc-paginator-container]:!px-2 [&_.mat-mdc-paginator-page-size]:!mr-2 [&_.mat-mdc-paginator-range-label]:!mx-2"
          >
          </mat-paginator>
        </div>
      </div>
    </section>
  </main>

  <app-footer-grid></app-footer-grid>
</ng-container>

<!-- ADD PAGE MODAL -->
<div
  *ngIf="showPlatformModal"
  class="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
  (click)="showPlatformModal = false"
>
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

  <div
    class="relative z-10 flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border border-gray-300 bg-white"
    (click)="$event.stopPropagation()"
  >
    <!-- MODAL HEADER -->
    <div class="border-b border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-4">
      <div class="grid grid-cols-12 items-center gap-4">
        <div class="col-span-10">
          <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            Add New Page
          </h2>
        </div>

        <div class="col-span-2 flex justify-end">
          <button
            mat-icon-button
            class="rounded-xl text-gray-500 transition hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300"
            (click)="showPlatformModal = false"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL CONTENT -->
    <div class="flex-1 overflow-y-auto bg-white p-4 sm:p-6">
      <app-create-site
        [embeddedMode]="true"
        [hasBorder]="false"
        [companyIdInput]="companyID.toString()"
        (onSubmitClbk)="onPageCreated($event)"
      >
      </app-create-site>
    </div>
  </div>
</div>